/**
 * DB の enum 型とアプリ側の型を 1 対 1 で対応させる定義。
 *
 * ここの値は `supabase/migrations/20260912000100_extensions_and_enums.sql` と
 * 完全に一致していなければならない。片方だけを変更してはいけない。
 */
export const USER_ROLES = ['USER', 'MODERATOR', 'ADMIN'];
/** 権限の強さ。数値比較で「MODERATOR 以上」を表現する。 */
export const ROLE_RANK = {
    USER: 0,
    MODERATOR: 1,
    ADMIN: 2,
};
export function hasAtLeastRole(actual, required) {
    return ROLE_RANK[actual] >= ROLE_RANK[required];
}
export const PROBLEM_STATUSES = ['DRAFT', 'PUBLIC', 'ARCHIVED'];
export const PROBLEM_DIFFICULTIES = ['EASY', 'MEDIUM', 'HARD', 'EXPERT'];
export const SUBMISSION_STATUSES = [
    'PENDING',
    'JUDGING',
    'ACCEPTED',
    'WRONG_ANSWER',
    'TIME_LIMIT_EXCEEDED',
    'MEMORY_LIMIT_EXCEEDED',
    'OUTPUT_LIMIT_EXCEEDED',
    'RUNTIME_ERROR',
    'COMPILATION_ERROR',
    'INTERNAL_ERROR',
    'SYSTEM_ERROR',
];
/** 判定がまだ確定していない状態。集計・統計から除外する。 */
export const PENDING_STATUSES = ['PENDING', 'JUDGING'];
export function isTerminalStatus(status) {
    return !PENDING_STATUSES.includes(status);
}
/** 一覧表示で使う短縮ラベル。 */
export const SUBMISSION_STATUS_ABBREV = {
    PENDING: 'WJ',
    JUDGING: 'WJ',
    ACCEPTED: 'AC',
    WRONG_ANSWER: 'WA',
    TIME_LIMIT_EXCEEDED: 'TLE',
    MEMORY_LIMIT_EXCEEDED: 'MLE',
    OUTPUT_LIMIT_EXCEEDED: 'OLE',
    RUNTIME_ERROR: 'RE',
    COMPILATION_ERROR: 'CE',
    INTERNAL_ERROR: 'IE',
    SYSTEM_ERROR: 'IE',
};
export const CONTEST_STATUSES = [
    'DRAFT',
    'REGISTRATION',
    'UPCOMING',
    'RUNNING',
    'ENDED',
    'ARCHIVED',
];
export const CONTEST_RULES = ['ICPC', 'IOI', 'CUSTOM'];
export const JUDGE_MODES = [
    'EXACT',
    'IGNORE_TRAILING_WHITESPACE',
    'FLOAT_TOLERANCE',
    'CUSTOM_CHECKER',
];
export const EDITORIAL_VISIBILITIES = ['ALWAYS', 'AFTER_CONTEST', 'AFTER_SOLVE'];
//# sourceMappingURL=enums.js.map